import * as mapvgl from 'mapvgl'
import yanmouStyle from '@/common/map.style.yanmou.js'
import loadBMapGL from '@/common/BMapGL.js'

import geoTowns from '@/components/geo-towns.js'
import volumnTowns from '@/components/volumn-towns.js'
import {
  geoPolygon
} from '@/common/MapTool.js'

export const mixins = {
  data() {
    return {
      map: null,
      view: null,
      convertor: null
    }
  },
  create() {},
  mounted() {
    loadBMapGL().then((BMapGL) => {
      console.log('BMapGL=', BMapGL);
      this.convertor = new BMapGL.Convertor()
      this.map = new BMapGL.Map('map-zone', {
        minZoom: 10.8,
        maxZoom: 18.8,
        style: {
          styleJson: yanmouStyle
        }
      })
      const {
        map
      } = this
      map.enableScrollWheelZoom()
      map.centerAndZoom(new BMapGL.Point(117.18, 32.12), this.defaultZoom)


      // const wms = BMapGL.XYZLayer({
      //   tileUrlTemplate: `http://localhost:8085/DataServer?tk=fcf0ace5ee9be989d49398ce15fafa42&T=img_w&x=[x]&y=[y]&l=[z]`,
      // })
      // map.addTileLayer(wms);


      this.view = new mapvgl.View({
        map: map,
      })

      const {
        view
      } = this



      // 初始化完成
      // 开始绘制初始的地图内容
      view.removeAllLayers()
      this.fly2(117.18, 32.12, 12.4).then(() => {
        // 乡镇轮廓
        const townsLyr = new mapvgl.PolygonLayer({
          fillColor: 'rgba(111, 160, 191, 0.5)', // 填充颜色
          lineColor: '#6fa0bf',
          lineWidth: 2,
          lineJoin: 'miter',
          enablePicked: true, // 是否可以拾取
          selectedIndex: -1, // 选中项
          selectedColor: 'rgba(111, 160, 191, 0.8)', // 选中项颜色
          autoSelect: true, // 根据鼠标位置来自动设置选中项
          onClick: (e) => {
            if (e && e.dataItem)
              vue.$router.push(`/industry/${e.dataItem.properties.Code}`)
          }
        })
        view.addLayer(townsLyr)
        townsLyr.setData(geoTowns.features)

        // 产量柱图和文字标签
        const features = []
        for (const i in volumnTowns) {
          const r = volumnTowns[i]
          features.push(Object.assign(geoPolygon(r.anchor, 0.5, 4), {
            properties: {
              height: r.volumn >= 20000 ? r.volumn * 0.05 + 4000 : r.volumn
            },
          }))
          const lbl = new BMapGL.Label(
            `
              <p class="town-name">${r.name}</p>
              <p class="town-volumn">${r.volumn} 亩</p>
              `, {
              position: new BMapGL.Point(r.anchor[0], r.anchor[1]),
              offset: new BMapGL.Size(10, -20)
            })
          lbl.setStyle({
            borderColor: 'rgba(0,0,0,0)',
            backgroundColor: 'rgba(0,0,0,0)',
          })
          map.addOverlay(lbl)
        }
        // 柱状图
        const volumnsLyr = new mapvgl.ShapeLayer({
          color: '#cf1505', // 柱状图颜色
          enablePicked: false, // 是否可以拾取
          riseTime: 900
        })
        view.addLayer(volumnsLyr)
        volumnsLyr.setData(features)
      })
    })
  },
  methods: {
    init() {
      const {
        BMapGL
      } = this

    },
    fly2(lng, lat, zoom, options) {
      return new Promise(resolve => {
        this.convert(lng, lat).then(p => {
          let opt = Object.assign({
            tilt: 60,
            heading: 0,
            callback: () => {
              resolve()
            }
          }, options ? options : {})
          this.map.flyTo(p, zoom, opt)
        })
      })
    },
    convert(m, n) {
      if ((typeof m) === 'number' && (typeof n) === 'number') {
        // 输入是2个数字
        return new Promise(resolve => {
          this.convertor.translate([new BMapGL.Point(m, n)], COORDINATES_WGS84, COORDINATES_BD09, (data) => {
            resolve(data.points[0])
          })
        })
      }
      if (m instanceof Array) {

      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/screen38496/map-zone/index-mixin.js